import React, { useState, useEffect, useCallback } from 'react';
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ModalSubtitle,
  ProgressBarContainer,
  ProgressBar,
  LoadingText,
  ModalHead
} from './styles';
import { getStatusById } from '../../services/solicitations';
import relojArena from '../../assets/images/reloj-arena.gif'
import { IoClose } from 'react-icons/io5';
import colors from '../../assets/styles/colors';

const LoadingModal = ({ isOpen, onClose, idCredito,estadoEsperado, labels, closeModal, onError, setShowModal }) => {
  const [currentLabelIndex, setCurrentLabelIndex] = useState(0);
  const [progress, setProgress] = useState(0);
  const [simulationComplete, setSimulationComplete] = useState(false);

  
  const validarEstado = useCallback(async () => {
    try {
      const response = await getStatusById(idCredito); 
      if (response.data == estadoEsperado) {
        setSimulationComplete(true);
        setProgress(100);
        // Pequeño retraso para que se vea la barra al 100% antes de cerrar
        setTimeout(() => {
          onClose(); 
        }, 500); 
      } else if(response.data == 'CONSULTA_CENTRALES_FALLO_TECNICO' || response.data == 'EN_VALIDACION_PROSPECCION'){
        setShowModal(false);
        onError();
      }
    } catch (error) {
      console.error("Error al validar el estado:", error);
    }
  }, [idCredito, onClose]); 

  useEffect(() => {
    if (!isOpen || simulationComplete) {
      return;
    }

    validarEstado();

    const interval = setInterval(() => {
      setCurrentLabelIndex(prevIndex => (prevIndex + 1) % labels.length);
      
      setProgress(prevProgress => {
        const newProgress = prevProgress + (100 / (labels.length * 2)); 
        return Math.min(newProgress, 95); 
      });

      validarEstado();

    }, 5000);

    return () => clearInterval(interval);
  }, [isOpen, simulationComplete, validarEstado]); 

  if (!isOpen && !simulationComplete) return null;

  return (
    <ModalOverlay>
      <ModalContent>
      <ModalHead>    
          {closeModal && <IoClose size={26} color={colors.textSecondary} onClick={closeModal} id="close-icon" />}    
        </ModalHead>
        <ModalTitle>¡Estamos procesando tu solicitud!</ModalTitle>
        <ModalSubtitle>Esto puede tardar unos minutos...</ModalSubtitle>
        <ProgressBarContainer>
          <ProgressBar progress={progress} />
        </ProgressBarContainer>
        <LoadingText>{labels[currentLabelIndex]}</LoadingText>
        <img 
            src={relojArena} 
            alt="Reloj de arena animado" 
            style={{ height: '75px' }}
          />
      </ModalContent>
    </ModalOverlay>
  );
};

export default LoadingModal;